import { replace } from 'connected-react-router';
import { reset } from 'redux-form';

import apiSubmitEmail from '../../utils/email/emailApi';
import dispatchTrueForOneSecond from '../../utils/dispatchTrueForOneSecond';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    onFinishMultiAction
} from '../Widget/actions';

import { RECORD_VIDEO_SEND_EMAIL_SUCCESS } from '../RecordVideo/actions';

import { CLOSE_DOUBLE_CHECK_REP_POPUP } from '../LocalRep/actions';

export const EMAIL_SUBMITTING = 'EMAIL_SUBMITTING';
export const EMAIL_SUBMITTING_ERROR = 'EMAIL_SUBMITTING_ERROR';
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const ON_EMAIL_MESSAGE_CHANGE = 'ON_EMAIL_MESSAGE_CHANGE';
export const ON_GO_TO_STEP2 = 'ON_GO_TO_STEP2';
export const ON_BACK_FROM_STEP2 = 'ON_BACK_FROM_STEP2';
export const SET_PREFIX_POPUP_VISIBILITY = 'SET_PREFIX_POPUP_VISIBILITY';
export const IS_BACK_TRANSITION = 'IS_BACK_TRANSITION';

let toasterTimeout = null;

export const redirectToFrontCard = (actionType) => dispatch => {
    const newRoute = actionType === 'recordvideo' ? '/recordvideo/email' : '/email/start';
    dispatch(replace(newRoute));
};

export const onEmailComplete = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    isMultiActionsCard,
    activeAction,
    recipientMask,
    representativeSearch,
    emailSubject,
    emailTopic,
    emailMessage,
    emailableReps,
    skipEndCard,
    isRecordVideoAction,
    answerId,
    recordVideoEmailData,
    partnerName,
    hiddenReps

) => dispatch => {
    dispatch({ type: CLOSE_DOUBLE_CHECK_REP_POPUP });

    dispatch({
        type: EMAIL_SUBMITTING,
        payload: true
    });      

    return apiSubmitEmail(
        apiRequestData,
        actionCompletedTime,
        values,
        localRepData,
        representativeSearch,
        emailSubject,
        emailTopic,
        emailMessage,
        isRecordVideoAction,
        answerId,
        recordVideoEmailData,
        partnerName,
        hiddenReps
    )
        .then(data => {
            const successType = isRecordVideoAction ? RECORD_VIDEO_SEND_EMAIL_SUCCESS : EMAIL_SUCCESS
            
            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }
            
            dispatch({
                type: successType,
                payload: {
                    ...data,
                    actionIdentifier: activeAction.identifier,
                    recipientMask
                }
            });

            setTimeout(()=>{
                dispatch({
                    type: EMAIL_SUBMITTING,
                    payload: false
                });
            },1000)

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: {
                    repsEmailed: emailableReps.filter(rep => !hiddenReps?.includes(rep.fullName)),
                    apiRequestData
                }
            });

            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP
            });


            if (isMultiActionsCard) {
                onFinishMultiAction(activeAction.identifier)(dispatch);
            } else if (!skipEndCard) {
                const newRoute = isRecordVideoAction ? '/recordvideo/emailsuccess' : '/email/success';
                dispatch(replace(newRoute));
            }

            dispatch(reset('emailDetailsFormMultiRepStep1'));
            dispatch(reset('emailDetailsFormMultiRepStep2'));
        })
        .catch(errorMessage => {
            dispatch({
                type: EMAIL_SUBMITTING_ERROR,
                payload:
                    'There was an error while submitting your form! Please try again later!'
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: EMAIL_SUBMITTING_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: EMAIL_SUBMITTING,
                payload: false
            });
        });
};

export const continueToStep2 = (values,isRecordVideoAction) => dispatch => {
    dispatch({
        type: ON_GO_TO_STEP2,
        payload: values
    });

    const newRoute = isRecordVideoAction ? '/recordvideo/multiRepStep2' : '/email/multiRepStep2';
    dispatch(replace(newRoute));
};

export const onBackToRecordVideoSuccess = (actionType) => dispatch => {
    dispatchTrueForOneSecond(dispatch, IS_BACK_TRANSITION)
    
    dispatch(replace('/recordvideo/successtoemail'));
};

export const onBackFromStep2 = (isRecordVideoAction) => dispatch => {

    dispatchTrueForOneSecond(dispatch, ON_BACK_FROM_STEP2)

    const newRoute = isRecordVideoAction ? '/recordvideo/successtoemail' : '/email';
    dispatch(replace(newRoute));

};

export const onEmailMessageChange = () => dispatch => {
    dispatch({
        type: ON_EMAIL_MESSAGE_CHANGE,
        payload: true
    });
};

export const setPrefixModalVisibility = val => dispatch => {
    dispatch({
        type: SET_PREFIX_POPUP_VISIBILITY,
        payload: val
    });
};
